import { render, staticRenderFns } from "./BCDPolicies.vue?vue&type=template&id=5d2500f4"
import script from "./BCDPolicies.vue?vue&type=script&lang=js"
export * from "./BCDPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports